import React, { useState } from 'react';
import { GetStaticProps, NextPage } from 'next';
import { getClient } from '../../../lib/sanity.server';
import { groq } from 'next-sanity';
import WhatsNewCard from '../../../components/learn/WhatsNewCard';
import GrayLink from '../../../components/GrayLink';

export interface WhatsNew {
  slug: string;
  createdAt: string;
  title: string;
  excerpt: string;
  body: string;
}

const WhatsNewPage: NextPage<{ posts: Array<WhatsNew> }> = ({ posts }) => {
  const [endPage, setEndPage] = useState<number>(10);
  const viewMoreClicked = (): void => setEndPage(page => page + 10);

  const displayedPosts = posts.map((post, index) =>
    index <= endPage ? <WhatsNewCard key={post.slug} whatsNew={post} /> : null
  );

  return (
    <div className='max-w-6xl mx-auto mb-32'>
      <div className='mt-32'>
        <GrayLink link='/learn' text='Learn' />
      </div>
      <h1 className='mt-2'>What&apos;s New</h1>
      <div className='mt-24'>{displayedPosts}</div>
      {posts.length > endPage && (
        <div
          className='mt-12 mb-12 text-center cursor-pointer text-primary body-paragraph'
          onClick={viewMoreClicked}
        >
          View More
        </div>
      )}
    </div>
  );
};

export const getStaticProps: GetStaticProps<{
  posts: WhatsNew[];
}> = async () => {
  const posts = await getClient().fetch<Array<WhatsNew>>(groq`
    *[_type == "whatsNew"] | order(_createdAt desc) {
      "slug": slug.current,
      "createdAt": _createdAt,
      title,
      excerpt
    }
  `);

  return {
    props: {
      posts,
    },
    revalidate: process.env.APP_ENV === 'production' ? 60000 : 1,
  };
};

export default WhatsNewPage;
